import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';

function Undermaintenance() {
    return (
        <>
            <Container sx={{ py: 6 }}>
                <Grid container spacing={2} sx={{ p: "30px 0" }}>
                    <Grid item xs={12} sx={{ textAlign: 'center', }}>
                        <Box sx={{
                            border: 1, p: {
                                xs: "40px 18px",
                                sm: "40px 30px",
                                md: "80px 40px",
                                lg: "100px 60px"
                            }, borderColor: "#ccc", borderRadius: 2
                        }}>
                            <Typography variant="h4" sx={{ fontSize: "22px", mb: "6px", fontWeight: 700, color: "var(--primaryMain)" }}>Scheduled Website Maintenance Notice</Typography>
                            <Typography sx={{ mb: 1.5 }}>To better serve our devotees and enhance your online experience,<br /> the SV Temple website will undergo a planned system upgrade on Tuesday, March 31st starting at 10:00 PM Eastern Time.</Typography>
                            <Typography sx={{ mb: 1.5 }}>During this maintenance window, the site will be temporarily unavailable. <br />Full access is expected to be restored by Wednesday, April 1st at 8:00 AM Eastern Time.</Typography>
                            <Typography>We sincerely apologize for any inconvenience this may cause and deeply appreciate your patience and continued support.<br /> If you encounter any issues after the upgrade, please reach out to us through the Contact Us form located under the About Us menu.</Typography>
                            <Typography sx={{ fontWeight: 600, mt: "20px" }}>- SV Temple Management</Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Container >
        </>
    );
}

export default Undermaintenance;
